import { dayjs } from "@outschool/time";

// Since day picker uses browser timezone and does not accept any other
// timezone param, it will not work properly when a user has selected a timezone
// that differs from their browser timezone. In order to make it work as expected,
// we remove the offset from the timezone conversion from dates passed into day picker
export const convertDate = (
  date: Date | string,
  timeZone: string,
  reverse?: boolean
) => {
  const dayjsDate = dayjs(date);
  const offsetMinutes =
    dayjsDate.utcOffset() - dayjsDate.tz(timeZone).utcOffset();

  const modifiedDate = reverse
    ? dayjsDate.add(offsetMinutes, "minutes")
    : dayjsDate.subtract(offsetMinutes, "minutes");

  return modifiedDate.toDate();
};
